import { ImageMediaUrl } from "@common/components/Media/component";
import Button from "@common/controls/Button/component";
import FormBlock from "@common/controls/Form/Block/component";
import Movement from "@common/controls/Movement/component";
import { useI18n } from "@common/hooks/i18n";
import date from "@common/lib/date";
import { usePromise } from "@common/lib/hooks";
import { i18nFormat } from "@common/lib/i18n";
import Network from "@common/modules/network/types";
import classNames from "classnames";
import * as React from "react";
import { getCompetitionBadge } from "./lib";

type Props = {
  competition: Network.Incentives.Incentive;
  getLeaderboardCount: (id: string) => Promise<number>;
  getLeaderboardItem: (id: string) => Promise<Network.Incentives.Api.IncentiveLeaderboardItem>;
  onClick: () => void;
  style?: React.CSSProperties;
};
export const CompetitionWidget = (props: Props) => {
  const i18n = useI18n();

  const [leaderboardItem] = usePromise<Network.Incentives.View.IncentiveLeaderboardItem>({
    fn: props.getLeaderboardItem,
    args: [props.competition.incentiveId],
    shouldLoad: true
  });

  const [leaderboardCount] = usePromise<number>({
    fn: props.getLeaderboardCount,
    args: [props.competition.incentiveId],
    shouldLoad: true
  });

  const movement = React.useMemo(() => leaderboardItem?.movement ?? 0, [leaderboardItem?.movement]);

  const isDisabled = React.useMemo(() => {
    const currentDate = date.getCurrentLocalDate();
    const startDate = date.startOfDay(props.competition.startDate);

    return currentDate < startDate;
  }, [props.competition.startDate]);

  return (
    <FormBlock className="affiliate_competition_block" isNarrow style={props.style}>
      <div
        className={classNames("root_container", { disabled: isDisabled })}
        onClick={isDisabled ? undefined : props.onClick}
      >
        {props.competition.coverPictureMediaUrl && (
          <ImageMediaUrl url={props.competition.coverPictureMediaUrl} coverMode="cover" />
        )}

        <div className="competition_data_container">
          <div className="description">
            <div className="name">{props.competition.name}</div>
            {leaderboardItem && (
              <>
                {i18nFormat(
                  i18n.affiliateCompetitionWidgetPositionInfo,
                  ["CURRENT_POSITION", leaderboardItem.position],
                  ["POSITION_COUNT", leaderboardCount ?? 0]
                )}
                {!!movement && <Movement value={movement} />}
              </>
            )}
          </div>
          <div className="action_container">
            {getCompetitionBadge(i18n, props.competition)}
            {!isDisabled && <Button type="white">{i18n.learnMore}</Button>}
          </div>
        </div>
      </div>
    </FormBlock>
  );
};
